export enum EnvironmentType {
	AGENCY,
	INDIVIDUAL,
	TEAMS
}
